var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nx-content-wizard',{ref:"wizard",attrs:{"type":"live","active":_vm.active},on:{"create":_vm.onCreate,"dismiss":_vm.onDismiss,"entityCreated":_vm.entityCreated}})}
var staticRenderFns = []

export { render, staticRenderFns }